import AsteriskSmallIcon from '@jetbrains/icons/asterisk-12px.svg?react'
import AsteriskIcon from '@jetbrains/icons/asterisk.svg?react'
import DiceIcon from '@jetbrains/icons/dice.svg?react'
import ExceptionIcon from '@jetbrains/icons/exception.svg?react'
import IgnoredIcon from '@jetbrains/icons/ignored.svg?react'
import MutedIcon from '@jetbrains/icons/muted.svg?react'
import FixedIcon from '@jetbrains/icons/ok.svg?react'
import SearchIcon from '@jetbrains/icons/search.svg?react'
import WarningIcon from '@jetbrains/icons/warning.svg?react'
import {SvgIcon} from '@jetbrains/teamcity-ui/dist/components'
import classNames from 'classnames'
import * as React from 'react'
import type {$Keys} from 'utility-types'

export const Icons = {
  error: ExceptionIcon,
  internal: WarningIcon,
  taken: SearchIcon,
  fixed: FixedIcon,
  muted: MutedIcon,
  'muted-red': MutedIcon,
  ignored: IgnoredIcon,
  flaky: DiceIcon,
  asterisk: AsteriskIcon,
}
type Icon = $Keys<typeof Icons>
const block = 'buildProblemIcon'

type Props = {
  className?: string
  type?: Icon
  isNew?: boolean
}

function BuildProblemIcon({type = 'error', isNew = false, className}: Props): React.ReactNode {
  const classes = classNames(block, className, `${block}_${type}`, 'svg-icon', {
    [`${block}_new`]: isNew,
  })

  const Icon = Icons[type]

  return (
    <span className={classes}>
      <SvgIcon icon={Icon} className={`${block}__icon`} />
      {isNew && <SvgIcon icon={AsteriskSmallIcon} className={`${block}__asterisk-small`} />}
    </span>
  )
}

export default React.memo(BuildProblemIcon)
